import deviceDetect from './deviceDetect';

export default class RedirectHandler {
    constructor(fakeWindow) {
        this.window = fakeWindow || window;
        this.init();
    }

    init() {
        if (!deviceDetect.phone()) return;

        const pageTabsDesktop = [
            'at-a-glance',
            'odds-comparison'
        ];

        const currentUrl = this.window.location.href;
        pageTabsDesktop.forEach((tabName) => {
            const urlModifierIndex = currentUrl.indexOf(tabName);

            if (urlModifierIndex === -1) return;

            const modifiedUrl = currentUrl.slice(0, urlModifierIndex);
            this.window.location.replace(modifiedUrl);
        });
    }
}




// WEBPACK FOOTER //
// ./lib/js/modules/redirectHandler.js